import styled from "styled-components";

export const Root = styled.div`
  padding-top: 105px;

  &.mobile {
    padding: 84px 0 0;

    h2 {
      font-size: 20px;
      line-height: 24px;
    }

    .sub {
      h2 {
        font-size: 22px;
        line-height: 26px;
      }
    }

    .desc {
      margin-top: 25px;
      line-height: 16px;
      font-size: 12px;
    }

    .dapp {
      width: auto;
    }

    .dapp1 {
      flex-direction: column-reverse;
      margin-top: 15px;
      padding: 0 12px;

      .info {
        width: auto;
        margin: 32px 0 0;

        h1 {
          font-size: 28px;
          line-height: 32px;
        }

        .desc {
          margin: 28px 0 25px;
          font-size: 12px;
          line-height: 16px;
        }
      }

      .img {
        min-height: 0;
        
        img {
          width: 80%;
          margin: 0 auto;
        }
      }
    }

    .functions {
      margin-top: 30px;
      text-align: left;

      ul {
        height: auto;
        flex-direction: column;
        padding: 30px 0;
      }

      li {
        display: flex;
        align-items: center;
        padding: 0 20px;

        &:not(:last-child) {
          margin-bottom: 40px;
        }
      }

      .name {
        margin: 0;
        font-size: 16px;
        line-height: 20px;
      }

      .desc {
        width: auto;
        margin: 10px 0 0;
        font-size: 12px;
        line-height: 16px;
      }

      img {
        width: 64px;
        margin-right: 20px;
        display: block;
      }
    }

    .accounts {
      margin-top: 30px;
      padding: 0 12px;
      text-align: left;

      ul {
        width: auto;
      }

      li {
        border-radius: 10px;
        height: auto;
        padding: 15px;
        font-size: 14px;
        position: relative;

        &.on {
          svg {
            transform: rotate(180deg);
          }
        }

        svg {
          position: absolute;
          right: 15px;
          top: 18px;
          transition: transform .4s ease-out;
        }

        &:not(:last-child) {
          margin-bottom: 15px;
        }
        
        h3 {
          margin-bottom: 10px;
          line-height: 1;
          font-size: 14px;
        }

        p {
          line-height: 16px;
          font-size: 12px;
        }
      }

      .li-img {
        display: none;
        opacity: 0;

        img {
          display: block;
          width: 100%;
          margin-bottom: 20px;
        }

        @keyframes show-item {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }

        &.on {
          display: block;
          animation: show-item 0.5s ease-in 1;
          animation-fill-mode: forwards;
        }
      }

      .desc {
        margin: 15px 0 20px;
      }
    }

    .subscription {
      width: auto;
      margin: 35px 15px 0;

      .desc {
        margin: 15px 0 25px;
      }

      .img {
        img {
          width: 100%;
        }
      }
    }

    .accounts, .subscription {
      .desc {
        width: auto;
      }
    }

    
  }

  h2 {
    font-size: 42px;
    line-height: 50px;
  }

  .desc {
    margin-top: 30px;
    line-height: 20px;
    color: #666666;
/* 
    p {
      text-indent: 2em;

      &:not(:last-child) {
        margin-bottom: 15px;
      }
    } */
  }

  .dapp {
    display: flex;
    align-items: center;
    width: 1200px;
    margin-top: 60px;
    box-sizing: border-box;

    .info {
      margin-right: 60px;
      width: 510px;

      h1 {
        font-size: 48px;
      }

      .desc {
        margin: 56px 0 60px;
        font-size: 18px;
        line-height: 26px;
        color: #333;

        p:not(:last-child) {
          margin-bottom: 15px;
        }
      }
    }

    .img {
      flex-shrink: 0;

      img {
        display: block;
      }
    }
  }

  .dapp1 {
    justify-content: space-between;
    margin-top: 100px;

    .img {
      min-height: 560px;
    }
  }

  .actions {
    display: inline-block;
    
    a {
      svg {
        margin-left: 5px;
      }
    }
  }

  .functions {
    background-color: #333;
    margin-top: 80px;
    color: #fff;
    text-align: center;

    &.show {
      .name, .desc {
        opacity: 1;
        transform: none;
      }
    }

    .name, .desc {
      transition: all .3s ease-out .3s;
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }

    li {
      &:nth-child(2) {
        .name, .desc {
          transition-delay: .6s;
        }
      }

      &:nth-child(3) {
        .name, .desc {
          transition-delay: .9s;
        }
      }
    }

    ul {
      height: 360px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .name {
      margin: 30px 0 20px;
      font-size: 22px;
      line-height: 26px;
      font-weight: bold;
    }

    .desc {
      transition-delay: 0.55s;
      width: 280px;
      margin: 0 auto;
      font-size: 14px;
      color: #ccc;
      line-height: 18px;
    }

    img {
      width: 146px;
    }
  }

  .accounts {
    margin-top: 100px;
    text-align: center;

    .desc {
      /* width: 1005px; */
      width: 745px;
      margin: 30px auto 78px;
    }

    .flex {
      display: flex;
      justify-content: space-between;
    }

    ul {
      width: 460px;
    }

    .end {
      li {
        transition: all .4s ease-out 0s;
      }
    }

    li {
      background-color: #fff;
      border-radius: 10px;
      border: 1px solid #eee;
      height: 112px;
      padding: 20px 25px;
      box-sizing: border-box;
      box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.03);
      color: #666;
      text-align: left;
      font-size: 14px;
      position: relative;
      /* left: -400px; */
      /* opacity: 0; */
      transition: all .4s ease-out 0s;
      cursor: pointer;

      &:not(:last-child) {
        margin-bottom: 35px;
      }

      &:hover {
        color: #999;

        h3 {
          color: #999;
        }
      }

      &.on {
        background: linear-gradient(180deg, #E9361B 0%, #C02C16 100%);
        color: #fff;

        h3 {
          color: #fff;
        }
      }

      h3 {
        margin-bottom: 15px;
        line-height: 1;
        font-size: 22px;
        color: #333;
      }

      p {
        line-height: 16px;
      }
    }

    .imgs {
      width: 680px;
      height: 406px;
      position: relative;
      box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.03);
      border-radius: 10px;

      @keyframes show {
        0% {
          opacity: 0;
          transform: translate3d(0, 0, 0) scale(0);
        }
        50% {
          opacity: 1;
        }
        100% {
          transform: translate3d(0, 0, 0) scale(1);
          opacity: 1;
        }
      }

      img {
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        transform-origin: right bottom;
        opacity: 1;

        &.on {
          animation: show 0.6s cubic-bezier(.77,1.46,1,.94) 1;
          transform: translate(0);
          opacity: 1;
        }
      }      
    }
  }

  .subscription {
    width: 1005px;
    margin: 100px auto 20px;
    text-align: center;

    .desc {
      width: 1005px;
      margin: 30px auto 50px;
    }

    .img {
      position: relative;

      img {
        display: block;
        margin: 0 auto;
        box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.05);
        border-radius: 10px;

        &:nth-child(2), &:nth-child(3) {
          position: absolute;
          right: 0;
          bottom: 0;
          transform: translateX(50px) translateY(100%);
          opacity: 0;
        }
      }

      @keyframes show2 {
        0% {
          opacity: 0;
          transform: translateX(50px) translateY(100%);
        }
        50% {
          opacity: 1;
        }
        100% {
          transform: translateX(-20px) translateY(12px);
          opacity: 1;
        }
      }

      @keyframes show3 {
        0% {
          opacity: 0;
          transform: translateX(50px) translateY(100%);
        }
        50% {
          opacity: 1;
        }
        100% {
          transform: translateX(20px) translateY(60px);
          opacity: 1;
        }
      }

      &.show {
        img {
          &:nth-child(2) {
            animation: show2 0.5s cubic-bezier(0,0,.46,.85) 0.4s 1;
            animation-fill-mode: forwards;
          }

          &:nth-child(3) {
            animation: show3 0.5s cubic-bezier(0,0,.46,.85) 0.9s 1;
            animation-fill-mode: forwards;
          }
        }
      }
    }
  }
`

export const Progress = styled.div`
  margin-top: 100px;
  background: #F5F5F5;
  padding-top: 35px;

  &.sub-process {
    .flex-reverse {
      .img {
        margin: 0 0 0 60px;
      }
      .info {
        margin-left: 150px;
      }
    }

    .img, .info {
      width: 540px;
    }
    .img {
      margin: 0 60px 0 0;
    }
    .info {
      margin: 82px 0 0 60px;
    }
  }

  &.sub-mobile {
    margin-top: 20px;
    padding-top: 40px;

    .flex {
      flex-direction: column;
      position: relative;
      padding: 0 0 10px 65px;
    }

    &.sub-process {
      .img {
        img {
          width: 85%;
        }
      }

      .flex-reverse {
        flex-direction: column-reverse;

        .img {
          margin: 0 0 40px;
        }
        .info {
          margin-left: 0;
        }
      }
    }

    .img, .info {
      width: auto;
      opacity: 1!important;
      transform: none!important;
    }

    .img {
      margin: 0 0 40px;
      padding: 0;

      img {
        width: 50%;
        display: block;
      }
    }

    .info {
      margin: 0;
      left: 0!important;
      
      h3 {
        margin-bottom: 25px;
        font-size: 18px;
      }

      p {
        margin-bottom: 20px;
        font-size: 12px;
        line-height: 14px;

        i {
          width: 12px;
          height: 12px;
          margin-right: 12px;
          border: 1px solid #E9361B;

          &::after {
            width: 7px;
            height: 7px;
          }
        }
      }
    }

    .line {
      position: absolute;
      left: 25px;
      top: 0;
      bottom: 0;
    }
  }

  .flex {
    display: flex;
    justify-content: center;
  }

  .img, .info {
    opacity: 0;
    transition: all .5s ease-out .4s;
  }
  .flex-reverse {
    .info {
      transform: translate3d(-100px, 0, 0);
    }
  }
  @keyframes scale1 {
    0%, 50%, 100% {
      height: 15px;
    }
    25%, 75% {
      height: 12px;
    }
  }
  .show {
    .line {
      &::after {
        height: 0;
      }
    }
    .info {
      opacity: 1;
      transform: none;
    }
  }

  .show-once {
    .img {
      opacity: 1;
      transform: none;
    }
  }

  .img, .info {
    width: 420px;
    margin: 0 60px;
  }

  .img {
    transition-delay: .8s;
    transform: translate3d(0, 100px, 0);
    padding-top: 10px;
    padding-bottom: 100px;
    text-align: center;
  }

  .info {
    transform: translate3d(100px, 0, 0);
    margin-top: 82px;
    line-height: 1;
    position: relative;

    h3 {
      white-space: nowrap;
      margin-bottom: 60px;
      font-size: 36px;
      font-weight: normal;
    }

    p {
      display: flex;
      align-items: center;
      margin-bottom: 40px;
      font-size: 20px;

      i {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 18px;
        height: 18px;
        margin-right: 12px;
        box-sizing: border-box;
        border: 2px solid #E9361B;
        border-radius: 50%;

        &::after {
          content: '';
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #E9361B;
        }
      }
    }
  }

  .line {
    width: 1px;
    background: linear-gradient(180deg, rgba(233, 54, 27, 1) 0%, #F5F5F5 100%);
    position: relative;
    margin-top: 15px;

    &::before {
      content: '';
      width: 15px;
      height: 15px;
      background: linear-gradient(180deg, #E9361B 0%, #C02C16 100%);
      border-radius: 50%;
      position: absolute;
      top: 0;
      transform: translateY(-100%);
      left: -7px;
      z-index: 1;
    }

    &::after {
      transition: height 1s linear 0s;
      content: '';
      position: absolute;
      width: 1px;
      bottom: 0;
      height: 100%;
      background-color: #F5F5F5;
    }
  }
`
